import type { ReactNode } from "react";

export default function MtfLayout({ children }: { children: ReactNode }) {
  return (
    <main className="legacy-light w-full px-6 py-6 xl:px-8 2xl:px-10">
      <h1 className="mb-4 text-xl font-semibold tracking-tight text-ink">
        Multi-Timeframe
      </h1>
      {children}
    </main>
  );
}
